var _rect, _rect2, _g, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 580,
    height: 846,
    transform: "translate(-120 -241)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_565_12442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 10.8333H8.33333C8.79167 10.8333 9.16667 10.4583 9.16667 10V3.33333C9.16667 2.875 8.79167 2.5 8.33333 2.5H3.33333C2.875 2.5 2.5 2.875 2.5 3.33333V10C2.5 10.4583 2.875 10.8333 3.33333 10.8333ZM3.33333 17.5H8.33333C8.79167 17.5 9.16667 17.125 9.16667 16.6667V13.3333C9.16667 12.875 8.79167 12.5 8.33333 12.5H3.33333C2.875 12.5 2.5 12.875 2.5 13.3333V16.6667C2.5 17.125 2.875 17.5 3.33333 17.5ZM11.6667 17.5H16.6667C17.125 17.5 17.5 17.125 17.5 16.6667V10C17.5 9.54167 17.125 9.16667 16.6667 9.16667H11.6667C11.2083 9.16667 10.8333 9.54167 10.8333 10V16.6667C10.8333 17.125 11.2083 17.5 11.6667 17.5ZM10.8333 3.33333V6.66667C10.8333 7.125 11.2083 7.5 11.6667 7.5H16.6667C17.125 7.5 17.5 7.125 17.5 6.66667V3.33333C17.5 2.875 17.125 2.5 16.6667 2.5H11.6667C11.2083 2.5 10.8333 2.875 10.8333 3.33333Z",
    fill: "#2E2B2E"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -19.5,
    y: -25.5,
    width: 379,
    height: 530,
    rx: 4.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_565_12442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDashboard);
export default __webpack_public_path__ + "static/media/icn_dashboard.ac2605b39e1f24735d6a836e0b744928.svg";
export { ForwardRef as ReactComponent };